/**
 * Parsed parked-GRANT seed types — the behavioral contract the inline
 * `[Edit Privileges]` popover consumes (VqeDdlEdit Slice F2). These outlived
 * the regex parser that originally produced them: the values are now derived
 * by the grammar-backed DSE2 GRANT/REVOKE extractor arm (VDE-2 Slice 1).
 *
 * Kept as a dedicated module so `grant.ts` stays focused on extraction logic
 * and the two UI consumers import a stable type home.
 */

export type ParsedGrantAction = 'grant' | 'revoke';

export type ParsedGrantPrincipalKind = 'user' | 'role' | 'public';

export interface ParsedGrantPrincipal {
  readonly kind: ParsedGrantPrincipalKind;
  readonly name: string;
  readonly quoted: boolean;
  readonly mysqlHost?: string;
}

export type ParsedGrantObjectKind =
  | 'table'
  | 'view'
  | 'sequence'
  | 'schema'
  | 'database'
  | 'function'
  | 'procedure'
  | 'package'
  | 'type'
  | 'tablespace'
  | 'role'
  | 'system';

export interface ParsedGrantObject {
  readonly kind: ParsedGrantObjectKind;
  readonly name?: string;
  readonly schema?: string;
  readonly quoted: boolean;
}

export interface ParsedParkedGrant {
  readonly action: ParsedGrantAction;
  readonly privileges: readonly string[];
  readonly object: ParsedGrantObject | null;
  readonly grantees: readonly ParsedGrantPrincipal[];
  readonly withGrantOption?: boolean;
  readonly cascade?: boolean;
  readonly pgsqlGrantOptionFor?: boolean;
}

export const GRANT_OBJECT_KIND_KEYWORDS: Record<string, ParsedGrantObjectKind> = {
  TABLE: 'table',
  VIEW: 'view',
  SEQUENCE: 'sequence',
  SCHEMA: 'schema',
  DATABASE: 'database',
  FUNCTION: 'function',
  PROCEDURE: 'procedure',
  PACKAGE: 'package',
  TYPE: 'type',
  TABLESPACE: 'tablespace',
};
